import { WorkflowStep } from './workflow-step.model';

export interface WorkflowCreationModel {
  workflowId?: string;
  name: string;
  description: string;
  steps: WorkflowStep[];
  workflowParameters: string[];
}
